import { render, staticRenderFns } from "./Article5Content.vue?vue&type=template&id=c1f487b0&scoped=true"
var script = {}
import style0 from "./Article5Content.vue?vue&type=style&index=0&id=c1f487b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f487b0",
  null
  
)

export default component.exports